import React, { useState } from 'react';
import { connect } from 'react-redux';

import { changePublicationListFilter } from '../publication.actions';
import { getPublicationAvailableFilters } from '../publication.selectors';

import {FilterItemDatePicker} from '../../common/sponsorships/filters/filterItemComponent';
import Filter from '../../common/sponsorships/filters/filter';
import { getDefaultRequestBuilder } from '../../common/sponsorships/filters/filterHelper';
import { getDefaultSelectedMonths } from '../../common/sponsorships/filters/dateFilterHelper';
import filterIds from '../../common/sponsorships/filters/filter_ids';
import { useAuth0, getSelectedTenantId } from '../../app/auth';

const PublicationListFiltersComponent = (props) => {

  const [builder] = useState(getDefaultRequestBuilder());
  const { getTokenSilently, user } = useAuth0();

  const addFilterParam = (filterId, itemId) => {
    builder.addParam(filterId, itemId);
    notifyFilterChanged();
  };

  const removeFilterParam = (filterId, itemId, silently=false) => {
    builder.removeParam(filterId, itemId);
    if (!silently) notifyFilterChanged();
  };

  const handleFilterSelection = (filterId, itemId, selected) => {
    if(selected) {
      addFilterParam(filterId, itemId);
    } else {
      removeFilterParam(filterId, itemId);
    }
  };

  const notifyFilterChanged = async() => {
    const token = await getTokenSilently();
    const queryString = builder.getQueryString();
    props.onFilterChanged(queryString, token, getSelectedTenantId(user, token));
  };

  const createCustomDatePicker = () => {
    return (
      <FilterItemDatePicker addFilterParam={addFilterParam} removeFilterParam={removeFilterParam} />
    );
  };

  const { months, publicationStatuses, priceBuckets } = props;

  const filterConfig = [
    { id: filterIds.DATE, title: 'Period', options: months, selectedOptions: getDefaultSelectedMonths(), allOption: false, renderCustomFilter: createCustomDatePicker },
    { id: filterIds.STATUS, title: 'Publication Status', options: publicationStatuses, allOption: false },
    { id: filterIds.PRICE, title: 'Price', options: priceBuckets, allOption: false }
  ];

  const filters = filterConfig.map(config => (
      <Filter key={config.id} filterId={config.id} filterSelectionChanged={handleFilterSelection} {...config} />
  ));

  return (
    <div>
      {filters}
    </div>
  );
};

function mapStateToProps(state) {
  const filters = getPublicationAvailableFilters(state) || {};

  let publicationStatuses = [];
  let priceBuckets = [];
  let months = [];
  let partners = [];

  if(filters && Object.keys(filters).length > 0) {
    publicationStatuses = filters.publicationStatuses;
    priceBuckets = filters.priceBuckets;
    months = filters.months;
    partners = filters.partners;
  }
  return { publicationStatuses, priceBuckets, months, partners };
}

function mapDispatchToProps(dispatch) {
  const props = {
    onFilterChanged: (queryString, token, tenantId) => {
      dispatch(changePublicationListFilter(queryString, token, tenantId));
    }
  };
  return props;
}

const PublicationListFilters = connect(mapStateToProps, mapDispatchToProps)(PublicationListFiltersComponent);
export default PublicationListFilters;